import { useMemo } from 'react';

import {
	LocationValue,
	getOpenCommentThreads,
	getVisibleCommentThreads,
	getAnnotationThreadKeys,
} from '@confluence/comments-panel-utils';
import { fg } from '@confluence/feature-gating';
import { useCommentsDataState } from '@confluence/comments-data';

export const useFooterComments = () => {
	const { orderedActiveAnnotationIdList, commentsDataMap, removedThreadsMap } =
		useCommentsDataState();

	return useMemo(() => {
		const footerCommentThreads = fg('confluence_frontend_immediate_comment_removal')
			? getVisibleCommentThreads({
					commentsDataMap,
					includeGeneralComments: true,
					includeInlineComments: false,
					orderedAnnotationIds: getAnnotationThreadKeys(orderedActiveAnnotationIdList),
				})
			: getOpenCommentThreads({
					commentsDataMap,
					showInlineComments: false,
					showGeneralComments: true,
					location: LocationValue.FOOTER,
					orderedActiveAnnotationIdList,
					removedThreadsMap,
				});

		const footerCommentIds = footerCommentThreads.map((thread) => thread.id);

		return {
			footerCommentIds,
			footerCommentThreads,
		};
	}, [commentsDataMap, orderedActiveAnnotationIdList, removedThreadsMap]);
};
